import { render } from "./mini-loader.vue?vue&type=template&id=3462fe53"
import script from "./mini-loader.vue?vue&type=script&lang=js"
export * from "./mini-loader.vue?vue&type=script&lang=js"

import "./mini-loader.vue?vue&type=style&index=0&id=3462fe53&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__